import React, {PureComponent, CSSProperties, ReactNode} from 'react'
import cxs from 'cxs/component'
import Theme, {mediaQueries} from 'Theme'
import {Scroll} from 'elements'

interface Props {
  title?: string
  children: ReactNode
  onClose?(): void
}

class Modal extends PureComponent<Props, object> {
  render() {
    const {title, children, onClose, ...props} = this.props
    const handleClose = onClose || (() => {})
    return (
      <Wrapper>
        <Backdrop onClick={handleClose} />
        <Content {...props}>
          {title && <Title>{title}</Title>}
          <Scroll>{children}</Scroll>
        </Content>
      </Wrapper>
    )
  }
}

export default Modal

const Wrapper = cxs('div')({
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 10
} as CSSProperties)

const Backdrop = cxs('div')({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: Theme.color.backdrop,
  zIndex: 'inherit'
} as CSSProperties)

const Title = cxs('div')({
  fontSize: Theme.fontSize.big,
  textAlign: 'center',
  padding: Theme.size.space[1],
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`
} as CSSProperties)

const Content = cxs('div')({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  margin: 'auto',
  transform: 'translateY(-50%)',
  top: '50%',
  maxWidth: '90%',
  maxHeight: '80%',
  backgroundColor: Theme.color.background,
  zIndex: 'inherit',
  [mediaQueries.desktop]: {
    maxWidth: '600px'
  } as CSSProperties
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modal.tsx